exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appLinkMainDiv{\r\n    display: none;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main